import { useAuthStore } from '@src/core/store/auth-store';
import { getCurrentOrgSlug } from '@src/shared/utils/get-org-id';

// Cache identity only. Authorization always remains on the API.
export function assistantScope(token = useAuthStore.getState().accessToken) {
  let user = 'signed-out';
  if (token) {
    try {
      const payload = JSON.parse(
        atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
      );
      user = String(payload.user_id ?? payload.sub ?? 'unknown');
    } catch {
      user = 'unknown';
    }
  }
  return `${getCurrentOrgSlug() ?? ''}:${user}`;
}

export function useAssistantScope() {
  const token = useAuthStore((state) => state.accessToken);
  return assistantScope(token);
}
